import React from 'react';
import { Link } from 'react-router-dom';

const NavUser = props => {
  return (
    <div className="nav__user">
      {props.isLoggedIn ? (
        <ul className="nav-menu-list">
          <li className="nav-menu-list-item nav-menu-list-item--desktop-only">
            <p onClick={props.logout} className={props.clientStyleVariation? "a--green": "a--blue"}>
              Sign Out
            </p>
          </li>
          <li className="nav-menu-list-item">
            <Link to="/" className={props.clientStyleVariation? "a--green": "a--blue"}>
              Dashboard
            </Link>
          </li>
        </ul>
      ) : (
        <ul className="nav-menu-list">
          <li className="nav-menu-list-item">
            <Link to="/new-client" className={props.clientStyleVariation? "btn btn--solid-green" :"btn btn--solid-blue "}>
              Sign Up
            </Link>
          </li>
          <li className="nav-menu-list-item nav-menu-list-item--desktop-only">
            <Link to="/login" className={props.clientStyleVariation? "a--green": "a--blue"}>
              Sign In
            </Link>
          </li>
        </ul>
      )}
    </div>
  );
};

export default NavUser;



// WEBPACK FOOTER //
// ./src/components/nav/NavUser.js